/** Konteksto ng customer (M29): card sa inbox, mga contact at ang customer 360 view. Shell created by WP-M29-SCHEMA1: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const customerContext = {
  card: {
    title: "Customer",
    verifiedBy: "Na-verify ng operator · {{time}}",
    setByStaff: "Itinakda ng staff · {{time}}",
    staleAt: "Luma na · huling update {{time}}",
    staleHint: "Mahigit isang araw nang hindi ina-update ng system mo ang customer na ito. Suriin muna bago umasa.",
    noContext: "Wala pang galing sa system mo",
    reference: "Reference",
    tier: "Tier",
    status: "Status",
    notSet: "Hindi pa naitakda",
    asOf: "Noong",
    personal: "Personal na datos",
    live: "Kusang nag-a-update habang bukas ang chat na ito.",
    loading: "Kinukuha ang customer",
    errorTitle: "Hindi na-load ang detalye ng customer",
    errorBody: "Hindi apektado ang chat mo. Subukan ulit sa ilang sandali.",
    retry: "Subukan ulit",
    statuses: {
      active: "Aktibo",
      restricted: "May limitasyon",
      suspended: "Naka-suspend",
      self_excluded: "Nag-self-exclude",
      closed: "Sarado",
      kyc_pending: "Naghihintay ng identity check",
    },
  },
  fields: {
    title: "Mga field mula sa system mo",
    empty: "Wala pang field mula sa system mo.",
    sourceAt: "{{source}} · {{time}}",
    yes: "Oo",
    no: "Hindi",
    source: {
      launch: "Secure launch",
      context_api: "Context API",
      signed_event: "Signed event",
      connector_sync: "Connector sync",
      console: "Staff",
    },
    columns: {
      reference: "Reference",
      tier: "Tier",
      status: "Status",
      source: "Pinagmulan",
    },
    noValue: "Walang value",
    stale: "Luma na",
    sourced: "Mula sa system mo",
  },
  reveal: {
    button: "Ipakita",
    hide: "Itago",
    buttonLabel: "Ipakita ang reference ng customer",
    hideLabel: "Itago ang reference ng customer",
    revealed: "Buong reference",
    needsPermission: "Kailangan ng pahintulot para sa buong reference. Magtanong sa owner o admin.",
    failed: "Hindi naipakita ang reference. Subukan ulit.",
    audited: "Naitatala sa audit log ang bawat pagpapakita.",
  },
  lookups: {
    title: "Mga lookup sa chat na ito",
    bound: "Nakatali sa customer na ito",
    empty: "Wala pang lookup sa chat na ito",
    emptyHint: "Kapag tiningnan ng assistant ang system mo para sa customer na ito, nakalista rito ang bawat tingin.",
    errorTitle: "Hindi na-load ang mga lookup",
    retry: "Subukan ulit",
    via: "sa pamamagitan ng {{connector}}",
    outcome: {
      ok: "Nasagot",
      stale: "Ginamit ang naka-save na value",
      failed: "Pumalya",
    },
    operations: {
      get_customer_support_profile: "Support profile ng customer",
    },
  },
  banner: {
    title: "Laging updated mula sa system mo",
    body: "Galing ang mga value na ito sa {{source}} at kusang nag-a-update. Huling update {{time}}.",
    bodyNoTime: "Galing ang mga value na ito sa {{source}} at kusang nag-a-update.",
    staleBody: "Mahigit isang araw na ang huling update.",
    drawerTitle: "Mga field ng customer",
    drawerEmpty: "Wala pang field na ipinadala ang system mo para sa customer na ito.",
    errorTitle: "Hindi na-load ang mga field ng customer",
    retry: "Subukan ulit",
    loading: "Kinukuha ang mga field ng customer",
  },
  timeline: {
    title: "Timeline",
    subtitle: "Pinakabago muna.",
    filterLabel: "Ipakita sa timeline",
    showAll: "Ipakita lahat",
    kinds: { chat: "Mga chat", ticket: "Mga ticket", context: "Katayuan", rating: "Mga rating" },
    entry: {
      chat: "Chat",
      chatUntitled: "Chat kasama ang customer",
      ticket: "Ticket {{number}}",
      context: "Nagbago ang katayuan",
      contextCreated: "Nagawa ang record ng customer",
      ratingChat: "Nag-rate ng chat",
      ratingTicket: "Nag-rate ng ticket {{number}}",
      pushedBy: "Galing sa {{source}}",
    },
    chatStatus: { open: "Bukas", waiting: "Naghihintay", resolved: "Nalutas", closed: "Sarado", abandoned: "Umalis sa chat" },
    ticketStatus: { new: "Bago", open: "Bukas", pending: "Naghihintay ng sagot ng client", on_hold: "Naka-hold", resolved: "Nalutas", closed: "Sarado" },
    handledBy: { ai: "Hinawakan ng assistant", staff: "Hinawakan ng kasamahan" },
    score: "{{score}} sa {{scale}}",
    change: {
      tier: "Tier",
      accountStatus: "Katayuan",
      displayName: "Pangalan",
      locale: "Wika",
      fromTo: "{{label}}: {{from}} → {{to}}",
      set: "Naitakda ang {{label}} sa {{to}}",
      cleared: "Binura ang {{label}} (dati: {{from}})",
      changed: "Nagbago ang {{label}}",
      hidden: "Personal na datos, hindi ipinapakita",
    },
    openChat: "Buksan ang chat",
    openTicket: "Buksan ang ticket",
    loadMore: "Ipakita ang mas luma",
    end: "Iyan na ang lahat sa ngayon.",
    loading: "Kinukuha ang timeline",
    empty: {
      title: "Wala pang laman ang timeline",
      body: "Lalabas dito ang mga chat, ticket, pagbabago ng katayuan at rating ng customer na ito habang nangyayari.",
      cta: "Buksan ang inbox",
      filteredTitle: "Walang tumutugma sa mga filter",
      filteredBody: "Ipakita lahat para makita ulit ang buong timeline.",
    },
    error: {
      title: "Hindi na-load ang timeline",
      body: "Walang binago. Subukan ulit sa ilang sandali.",
      retry: "Subukan ulit",
    },
  },
  /** Settings > Attributes: ang switch na "Makikita ito ng AI" (PDI-007, WP-M29-AI-CONTEXT). */
  aiVisible: {
    label: "Makikita ito ng AI",
    hint: "Kapag naka-on, mababasa ng assistant ang value na ito sa isang maikling linya tungkol sa customer. Hindi kailanman makakarating sa assistant ang reference number ng customer.",
    column: "AI",
    on: "Makikita ng AI",
    off: "Hindi ibinabahagi",
    notApplicable: "Hindi naaangkop",
    personal: "May personal na datos ito, kaya naka-off ito maliban kung i-on mo. Ang mga numero ng telepono, e-mail at katulad na value ay tinatakpan bago makita ng assistant.",
    hidden: "Nakatago ang field na ito sa assistant, kaya hindi ito mapapa-on.",
    visitorOnly: "Mga attribute lang ng customer (visitor) ang maipapakita sa assistant.",
  },
};
